module.exports = __webpack_public_path__ + "img/dash-card-bg-1.fa53aec7.svg";